import React from 'react';
import {useTranslation} from 'react-i18next';

// import download from '@/assets/images/download.png';

const AssetsSelection = ({plan}) => {
  const {t: tr} = useTranslation('planDetail');

  return (
    <article style={{borderLeft: '0px'}}>
      <h4>{tr('assets_selection')}</h4>
      <section className='plan-details'>
        <a
          href={plan.assetsSelectionFilePath}
          target='_blank'
          rel='noopener noreferrer'
        >
          {tr('assets_performance_information')}
        </a>
      </section>
    </article>
  );
};

export default AssetsSelection;
